/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Navigate } from "react-big-calendar";
import PropTypes from "prop-types";
import { format } from "date-fns";

import CalendarWeekDayColumn from "./CalendarWeekDayColumn";
import { filteredCourses } from "../../../helpers/event";
import { useClassFilters } from "./ClassFilterProvider";

const CalendarWeekView = (props) => {
	const {
		components: { coursesByDate, event: eventComp },
		date,
		getters: { dayProp },
		localizer: { add, startOf },
		events
	} = props;
	const { filters } = useClassFilters();

	const [firstDay, setFirstDay] = useState(new Date());
	useEffect(() => {
		const firstDayOfWeek = startOf(date, "week");
		const dayPropRes = dayProp();
		setFirstDay(firstDayOfWeek);
	}, [date]);

	const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

	return (
		<Card className="rbc-week-view">
			<Card.Header className="d-flex bg-neutral11 text-neutral5 p-0">
				{days.map((day) => <div className="rbc-header flex-fill text-center mb-0 text-neutral5" key={day}>{day}</div>)}
			</Card.Header>
			<Card.Body>
				<div className="d-flex">
					{days.map((day, idx) => (
						<CalendarWeekDayColumn
							courses={filteredCourses(coursesByDate[format(add(firstDay, idx, "day"), "yyyy-MM-dd")] || [], filters)}
							date={add(firstDay, idx, "day")}
							eventComp={eventComp}
							key={day}
						/>))}
				</div>
			</Card.Body>
		</Card>
	);
};

CalendarWeekView.propTypes = {
	date: PropTypes.instanceOf(Date).isRequired,
	events: PropTypes.arrayOf(PropTypes.shape({})),
	localizer: PropTypes.shape({
		add: PropTypes.func,
		startOf: PropTypes.func
	}).isRequired
};

CalendarWeekView.defaultProps = {
	events: []
};

CalendarWeekView.navigate = (date, action, { localizer }) => {
	switch (action) {
	case Navigate.PREVIOUS:
		return localizer.add(date, -3, "day");

	case Navigate.NEXT:
		return localizer.add(date, 3, "day");

	default:
		return date;
	}
};

CalendarWeekView.title = () => "Week View";

export default CalendarWeekView;
